import * as t from "../actions";
import * as _ from "lodash";

const initialEndpointState: any = {
  email: {
    checked: false,
    details: {
      subject: "",
      recipiants: []
    }
  },
  ftp: {
    checked: false,
    details: {
      name: "",
      hostname: "",
      port: 21,
      path: "",
      username: "",
      password: ""
    }
  },
  sftp: {
    checked: false,
    details: {
      name: "",
      hostname: "",
      port: 22,
      path: "",
      username: "",
      password: ""
    }
  }
};

// todo type
export default function (state = initialEndpointState, action: any) {
  switch (action.type) {
    case t.TOGGLE_FTP:
      return {
        ...state,
        ftp: {
          ...state.ftp,
          checked: !state.ftp.checked
        }
      };

    case t.TOGGLE_SFTP:
      return {
        ...state,
        sftp: {
          ...state.sftp,
          checked: !state.sftp.checked
        }
      };

    case t.TOGGLE_EMAIL:
      return {
        ...state,
        email: {
          ...state.email,
          checked: !state.email.checked
        }
      };

    case t.EDIT_ENDPOINT:
      let endpoint = _.cloneDeep(state[action.payload.target]);
      endpoint.details[action.payload.name] = action.payload.value;

      return {
        ...state,
        [action.payload.target]: endpoint
      };

    case t.ADD_REPORT:
      let stateCpy = _.cloneDeep(state);

      action.payload.endpoints.forEach((ep: any) => {
        switch (ep.endpoint_type) {
          case "Endpoint::Email":
            stateCpy = {
              ...stateCpy,
              email: {
                checked: true,
                details: Object.assign({}, stateCpy.email.details, ep.endpoint)
              }
            };
            break;

          case "Endpoint::Ftp":
            stateCpy = {
              ...stateCpy,
              ftp: {
                checked: true,
                details: Object.assign({}, stateCpy.ftp.details, ep.endpoint)
              }
            };
            break;

          case "Endpoint::Sftp":
            stateCpy = {
              ...stateCpy,
              sftp: {
                checked: true,
                details: Object.assign({}, stateCpy.sftp.details, ep.endpoint)
              }
            };
            break;

          default:
            console.warn(`Unknown endpoing type ${ep.endpoint_type}`);
        }
      });
      return stateCpy;

    case t.FLUSH_REPORT:
      return initialEndpointState;

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./client/modules/ReportForm/reducer/endpoint.ts